import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box, Card, Typography, Tab, Tabs } from "@mui/material";
import Header from "src/Component/content-component/Header";

const CoursesOffered = ({ courses }) => {
  const settings = {
    infinite: true,
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 800, settings: { slidesToShow: 2 } },
      {breakpoint: 500,  settings: {slidesToShow: 1, slidesToScroll: 1, speed: 4000, infinite: true, }, }
    ],
  };

  return (
    <Box sx={{ textAlign: "center", mt: 4, mb: 6, px: { xs: 2, sm: 5, md: 20 } }}>
       <Header color="#00999e" textAlign="center" content="Courses Offered" sx={{ mb: 3 }} />
      <Box
        sx={{
          width: "100%",
          padding: "15px",
          bgcolor: "background.paper",
          boxShadow: "0px 4px 8px rgba(0.3, 0.3, 0.3, 0.3)",
        }}
      >
        <Tabs
          variant="scrollable"
          scrollButtons={true}
          aria-label="scrollable prevent tabs example"
          TabIndicatorProps={{ style: { backgroundColor: "blue", height: 0 } }}
          sx={{ "& .MuiTabs-flexContainer": { display: "flex", justifyContent: "space-around" } }}
        >
          <Tab
            label="Popular Programs"
            sx={{
              fontSize: "16px",
              color: "#00999E",
              "&.Mui-selected": { backgroundColor: "#00999E", color: "white"},
            }}
          />
        </Tabs>
      </Box>
      <Box mt={6}>
        <Slider {...settings}>
          {courses.map((item, index) => (
            <Box key={index} sx={{ px: 1, mb: 4 }}>
              <Card
                sx={{
                  width: "220px",
                  height: "240px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  padding: 2,
                  boxShadow: 3,
                  position: "relative",
                  transition: "background 0.3s ease",
                  ":hover": { background: "#63D7DB" },
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    height: "120px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    overflow: "hidden",
                    borderRadius: "5px",
                  }}
                >
                  <img
                    src={item.Image}
                    alt={item.title}
                    style={{ width: 110, height: 110 }}
                  />
                </Box>
                <Box
                  sx={{ height: "60px", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}
                >
                  <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                    {item.title}
                  </Typography>
                </Box>
              </Card>
            </Box>
          ))}
        </Slider>
      </Box>
    </Box>
  );
};

export default CoursesOffered;
